import Element from '../element/Element';
import AudioTip from './AudioTip';
import type AudioTooltipModel from './AudioTooltipModel';
import type AudioTipModel from './AudioTipModel';
import List from 'ln/list/List';
import ListRenderer from 'ln/list/ListRenderer';

export default class AudioTooltip extends Element {

    model:AudioTooltipModel;

    constructor( model:AudioTooltipModel ) {
        super( model, 'lm.audio-tooltip-element' );
    }

    init() {
        this.renderTips();
        for( const tipModel of this.model.tooltips ) {
            tipModel.change.add( () => {
                if( tipModel.playing ) {
                    for( const otherTipModel of this.model.tooltips ) {
                        if( otherTipModel !== tipModel ) {
                            otherTipModel.playing = false;
                        }
                    }
                }
            } );
        }
    }

    private renderTips() {
        const renderer = new ListRenderer<AudioTipModel>( this.node.js( 'tooltips' ) );
        renderer.defaultRender( tipModel => {
            return { node: new AudioTip( tipModel ).render().node };
        });
        renderer.source = new List<AudioTipModel>( this.model.tooltips );
    }
}
